export default __webpack_public_path__ + "d71b40536bc5bbd0b8fff75600287a6c.svg";